/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./MatKhauDangNhap.scss";
import { Notify } from "../../../../component/Notify";
import { Loading } from "../../../../component/Loading";
import {
  getFromlocalstorage,
} from "../../../../component/MaHoaDuLieu";

function MatKhauDangNhap() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [Message, setMessage] = useState("");
  const [typenoti, settypenoti] = useState("error");

  const apiUrl = process.env.REACT_APP_API_BACKEND;
  const data =
    JSON.parse(getFromlocalstorage("data_u"));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!oldPassword || !newPassword || !confirmPassword) {
      setMessage("กรุณากรอกข้อมูลให้ครบถ้วน");
      settypenoti("error");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("รหัสผ่านใหม่ไม่ตรงกัน");
      settypenoti("error");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/postrepass/${data._id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          password_old: oldPassword,
          password: newPassword,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setMessage("อัปเดตรหัสผ่านสำเร็จ");
        settypenoti("success");
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        setMessage(
          result.message === "รหัสผ่านเดิมไม่ถูกต้อง"
            ? "รหัสผ่านเดิมไม่ถูกต้อง"
            : "อัปเดตรหัสผ่านไม่สำเร็จ"
        );
        settypenoti("error");
      }
    } catch (error) {
      setMessage("เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน");
      settypenoti("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: "110px" }}>
      <form onSubmit={handleSubmit}>
        <div className="matkhau_dn_lwrap">
          <div className="matkhau_dn_cell">
            <div className="matkhau_dn_cell_icon">
              <FontAwesomeIcon
                icon={faLock}
                className="matkhau_dn_cell_icon_icon"
              />
            </div>
            <div className="matkhau_dn_cell_input">
              <input
                type="password"
                placeholder="กรอกรหัสผ่านปัจจุบัน"
                required
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="matkhau_dn_cell">
            <div className="matkhau_dn_cell_icon">
              <FontAwesomeIcon
                icon={faLock}
                className="matkhau_dn_cell_icon_icon"
              />
            </div>
            <div className="matkhau_dn_cell_input">
              <input
                type="password"
                placeholder="กรอกรหัสผ่านใหม่"
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="matkhau_dn_cell">
            <div className="matkhau_dn_cell_icon">
              <FontAwesomeIcon
                icon={faLock}
                className="matkhau_dn_cell_icon_icon"
              />
            </div>
            <div className="matkhau_dn_cell_input">
              <input
                type="password"
                placeholder="กรอกรหัสผ่านใหม่อีกครั้ง"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
          </div>
        </div>

        <p style={{ textAlign: "center", marginTop: "10px" }}>
          <button className="matkhau_dn_submit_btn" type="submit">
            ยืนยัน
          </button>
        </p>
      </form>

      {Message && (
        <Notify message={Message} type={typenoti} setcontent={setMessage} />
      )}

      <Loading isLoading={loading} />
    </div>
  );
}

export default MatKhauDangNhap;
